import React, { useState, useEffect } from 'react';
/* eslint-disable */
import * as Yup from 'yup';

// material
import { Container, Card } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';

import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, InputAdornment, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import { AESEncryptionParam } from '../../../../helpers/AesEncrypt';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';

//table start

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

//table end

function createData(collectionCenter, crop, supplier, first, second, third, fourth, fifth, total) {
  return { collectionCenter, crop, supplier, first, second, third, fourth, fifth, total };
}

const rows = [
  createData('', '', ' ', 'Qty(Kg)12 LKR ', 'Qty(Kg)1 LKR ', 'Qty(Kg)1 LKR ', 'Qty(Kg)1 LKR ', 'Qty(Kg)1 LKR', ''),

  createData('Boralanda', 'Capsicum', ' ', ' ', ' ', ' ', ' ', '', ''),

  createData('', '', 'Saunil K M ', '250 | 95.00 ', '450 | 95.00 ', '350 | 95.00 ', '550 | 95.00', '100 | 95.00', '1000'),

  createData('', '', 'Nimal S A ', '', '4500| 95.00', '3500 | 95.00', '', '1000 | 95.00', '900'),

  createData('Boralanda', 'Beef Tomato', ' ', ' ', ' ', ' ', ' ', '', ''),

  createData('', '', 'Saunil K M ', '250 | 95.00 ', '450 | 95.00', '350 | 95.00', '550 | 95.00', '100 | 95.00', '1000'),

  createData('', '', ' ', ' ', ' ', ' ', '', ''),


];

const useStyles = makeStyles({
  table: {
    minWidth: 700
  }
});

export default function CollectionReport(props) {
  const classes = useStyles();

  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('ashPlantain');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);
  //Table finish

  const [productList, setProductList] = useState([]);
  const [productcatogery, setProductcatogery] = useState([]);
  const [isTable, setIsTable] = useState(false);
  let encrypted = '';
  const navigate = useNavigate();

  const productcatogerySearchSchema = Yup.object().shape({
    group: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntity: Yup.number().min(1, 'Please Select Operation Entity').required('Operation Entity Required'),
    collectionCenter: Yup.number().min(1, 'Please Select  Collection Center').required('Collection Center Required'),
    product: Yup.number().min(1, 'Please Select Product').required('Product Required'),
    fromDate: Yup.date().min(1, 'Please Select the Date').required('From Date Required'),
    toDate: Yup.date().min(1, 'Please Select to Date').required(' To Date Required'),
  });
  const [date, setDate] = React.useState(new Date());
  const formik = useFormik({
    initialValues: {
      group: '1',
      operationEntity: '1',
      fromDate: date.toISOString().split('T')[0],
      product: '0',
      toDate: date.toISOString().split('T')[0],
      collectionCenter: '0',
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      SubmitForm(values);
    }
  });

  async function SubmitForm(value) {
    await timeout(1000);
    setIsTable(true);
  }

  async function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const { errors, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  return (
    <Page title="Product Creation |  FAPS">
      <Container>
        <CommonPageHeader
          path={'/createCropForcast'}
          btname="Add"
          pageName="Collection Center Demand Details Report"
          leftButtonHidden={true}
        />

        <FormikProvider value={formik}>
          <ToastContainer position="bottom-right" pauseOnHover />
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Stack spacing={2}>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Group *"
                  value={formik.values.group}
                  onChange={formik.handleChange}
                  {...getFieldProps('group')}
                  error={Boolean(touched.group && errors.group)}
                  helperText={touched.group && errors.group}
                >
                  <MenuItem key={0} value={0}>
                    {' '}
                    Select Group
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Operation Entity *"
                  value={formik.values.operationEntity}
                  onChange={formik.handleChange}
                  {...getFieldProps('operationEntity')}
                  error={Boolean(touched.operationEntity && errors.operationEntity)}
                  helperText={touched.operationEntity && errors.operationEntity}
                >
                  <MenuItem key={0} value={0}>
                    {' '}
                    Operation Entity
                  </MenuItem>
                  <MenuItem value={1}> Cargills</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Collection Center *"
                  value={formik.values.collectionCenter}
                  onChange={formik.handleChange}
                  {...getFieldProps('collectionCenter')}
                  error={Boolean(touched.collectionCenter && errors.collectionCenter)}
                  helperText={touched.collectionCenter && errors.collectionCenter}
                >
                  <MenuItem key={0} value={0}>All Collection Center</MenuItem>
                  <MenuItem value={1}> Thanamalvila</MenuItem>
                  <MenuItem value={2}> Nuwara Eliya</MenuItem>
                </TextField>
                <TextField
                  select
                  fullWidth
                  size="small"
                  label="Product *"
                  value={formik.values.product}
                  onChange={formik.handleChange}
                  {...getFieldProps('product')}
                  error={Boolean(touched.product && errors.product)}
                  helperText={touched.product && errors.product}
                >
                  <MenuItem key={0} value={0}>All Product</MenuItem>
                  <MenuItem value={1}> Ash Plantain</MenuItem>
                  <MenuItem value={2}> Brinja</MenuItem>
                </TextField>
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                <TextField
                  fullWidth
                  size="small"
                  id="fromDate"
                  label="From Date *"
                  type="date"
                  defaultValue=""
                  value={formik.values.fromDate}
                  onChange={formik.handleChange}
                  {...getFieldProps('fromDate')}
                  error={Boolean(touched.fromDate && errors.fromDate)}
                  helperText={touched.fromDate && errors.fromDate}
                  InputLabelProps={{
                    shrink: true
                  }}
                />
                <TextField
                  fullWidth
                  size="small"
                  id="toDate"
                  label="To Date *"
                  type="date"
                  defaultValue=""
                  value={formik.values.toDate}
                  onChange={formik.handleChange}
                  {...getFieldProps('toDate')}
                  error={Boolean(touched.toDate && errors.toDate)}
                  helperText={touched.toDate && errors.toDate}
                  InputLabelProps={{
                    shrink: true
                  }}
                />

              </Stack>




            </Stack>
            <br />
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
              <Button type="submit" color="secondary" variant="outlined">
                Search
              </Button>
            </Stack>
          </Form>
        </FormikProvider>

        <br />
        <Divider variant="middle" />
        <br />
        {/* TAble  */}


        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <Card style={{ justifycontent: 'center', width: '100rem' }}>
            <Paper className={classes.paper}>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ fontWeight: 'bold' }}>Collection Center</TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        Crop
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        Supplier
                      </TableCell>

                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        1st
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        2nd
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        3rd
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        4th
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        5th
                      </TableCell>
                      <TableCell align="left" style={{ fontWeight: 'bold' }}>
                        Total
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row) => (
                      <StyledTableRow>
                        <TableCell lign="left"> {row.collectionCenter}</TableCell>
                        <TableCell align="lef">{row.crop}</TableCell>
                        <TableCell align="left">{row.supplier}</TableCell>

                        <TableCell align="left"> {row.first} </TableCell>
                        <TableCell align="left"> {row.second} </TableCell>
                        <TableCell align="left"> {row.third} </TableCell>
                        <TableCell align="left"> {row.fourth} </TableCell>
                        <TableCell align="left"> {row.fifth} </TableCell>
                        <TableCell align="left"> {row.total} </TableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Card>
        </Stack>


        <br />

        <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
          <Button type="submit" color="secondary" variant="outlined">
            PDF
          </Button>
          <Button type="submit" color="secondary" variant="outlined">
            Excel
          </Button>
        </Stack>

      </Container>
    </Page>
  );
}
